import { Badge } from "@/components/ui/badge";
import { SERVICE_ORDER_STATUSES, STATUS_COLORS, labelFrom, toneFrom } from "@/lib/constants";

export function StatusBadge({ status, className = "", "data-testid": testId }) {
  const tone = toneFrom(SERVICE_ORDER_STATUSES, status);
  const cls = STATUS_COLORS[tone] || STATUS_COLORS.slate;
  return (
    <Badge className={`${cls} ${className}`} data-testid={testId}>
      {labelFrom(SERVICE_ORDER_STATUSES, status)}
    </Badge>
  );
}

export function ToneBadge({ list, value, className = "", "data-testid": testId }) {
  const tone = toneFrom(list, value);
  const cls = STATUS_COLORS[tone] || STATUS_COLORS.slate;
  return (
    <Badge className={`${cls} ${className}`} data-testid={testId}>
      {labelFrom(list, value)}
    </Badge>
  );
}
